import { Component, inject, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Hiring } from '../../../../classes/hiring';
import { HiringService } from '../../../../services/hiring.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-hiring-input',
    standalone: false,
    templateUrl: './hiring-input.component.html',
    styleUrl: './hiring-input.component.scss',
})
export class HiringInputComponent extends InputComponent implements OnInit {
    private hiringService = inject(HiringService);

    hiring$: Observable<Hiring[]>;

    ngOnInit() {
        this.hiring$ = combineLatest(this.field.dataFilter.map(etKey => this.hiringService.getByType(etKey))).pipe(
            map(results => results.flat().filter((h, index, self) => self.findIndex(x => x.id === h.id) === index))
        );
    }
}
